import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-extra-curricular-events',
  templateUrl: './extra-curricular-events.component.html',
  styleUrls: ['./extra-curricular-events.component.scss']
})
export class ExtraCurricularEventsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
